import { Box, Button, ButtonGroup, Dialog, Fab, Icon, List, Modal, Paper, Slide, TextField, Typography, useMediaQuery, useTheme } from "@mui/material"
import React, { forwardRef, Ref, useEffect } from "react"
import ClearIcon from '@mui/icons-material/Clear';
import 'aos/dist/aos.css';

import Aos from 'aos'
const modalGenesData = {

  "ATM": {
    "title": "ATM",
    "subtitles": [{
      "title": "¿Qué es ATM?",
      "subtitle": [{
        "desc": "ATM es un gen que ayuda a reparar el daño a su ADN. Las personas que nacen con cambios, llamados mutaciones, en el gen ATM tienen un mayor riesgo de ciertos tipos de cáncer.",
        "list": []
      }]
    },
    {
      "title": "¿Qué cánceres están asociados con una mutación ATM?",
      "subtitle": [{
        "desc": "Las personas con un mutación hereditaria en su gen ATM tienen un mayor riesgo de ciertos tipos de cáncer, que incluyen:",
        "list": ["Seno", "Trompa de falopio", "ovarico", "pancreatico", "colorrectal", "prostata"]
      }]
    },
    {
      "title": "¿Puede el ATM saltarse una generación?",
      "subtitle": [{
        "desc": `ATM es un gen. Los genes no se saltan generaciones\n Las mutaciones en el gen ATM pueden transmitirse de padres a hijos, pero las mutaciones tampoco saltan generaciones. Cada persona con una mutación ATM tiene un 50% de posibilidades de transmitir su mutación a cada uno de sus hijos. Los niños que no heredaron la mutación ATM de sus padres no pueden transmitir la mutación a sus hijos.\n
          El cáncer puede saltarse generaciones. \n
          Algunas personas con una mutación ATM nunca desarrollan cáncer. Todavía pueden transmitir su mutación a sus hijos. Un niño que hereda la mutación ATM de sus padres tendrá un mayor riesgo de cáncer. Si un padre con una mutación nunca desarrolla cáncer, pero su hijo que heredó su mutación desarrolla cáncer, puede parecer que la mutación se ha saltado una generación.
          `, "list": []
      }]
    },
    {
      "title": "¿Qué pueden hacer las personas con una mutación ATM?",
      "subtitle": [{
        "desc":
          "Las personas con una mutación ATM tienen opciones para la detección, la prevención y el tratamiento de cáncer hereditario. Existen directrices de expertos y ensayos clínicos que se centran en:",
        "list": ["Cribado y detección precoz",
          "Reducción de riesgos",
          "tratamiento"]
      },

      {
        "desc": `Estas pautas se basan en las investigaciones más actuales y se actualizan anualmente. Las personas que dan positivo para una mutación ATM deben hablar con un experto en genética para asegurarse de que su atención médica se base en la información más actualizada.`,
        "list": []
      },
      {
        "desc": `Puede haber otras preocupaciones médicas para las personas con una mutación ATM, incluida una enfermedad infantil rara conocida como Ataxia-Telangiesctasia (AT) que puede ocurrir en personas que heredan una mutación en ambas copias de su gen ATM.`,
        "list": []
      },
      {
        "desc": `Si da positivo para una mutación ATM, debe informar a sus parientes consanguíneos cercanos (parientes de primer, segundo y tercer grado) sobre los resultados de su prueba y alentarlos a hablar con un experto en genética.`,
        "list": []
      }
      ]
    }
    ]

  },

  "APC": {
    "title": "APC",
    "subtitles": [
      {
        "title": "¿Qué es APC?",
        "subtitle": [
          {
            "desc": "APC es un gen supresor de tumores. Cuando funciona correctamente, ayuda a impedir que se desarrolle cáncer.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué cánceres están asociados con una mutación en APC?",
        "subtitle": [
          {
            "desc": "Las personas con una mutación en APC tienen un mayor riesgo de cáncer, en particular de cáncer colorrectal. Las mutaciones de APC y sus riesgos se dividen en tres categorías:",
            "list": ["FAP (poliposis adenomatosa familiar)", "FAP atenuada (AFAP)", "APC I1307K"]
          }
        ]
      },
      {
        "title": "Diferencias de riesgo según el tipo de mutación",
        "subtitle": [
          {
            "desc": "Los riesgos de por vida varían mucho según el tipo de mutación. FAP y AFAP confieren un riesgo muy alto de cáncer; la variante APC I1307K se asocia a un aumento leve del riesgo.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué es FAP? ¿Qué es AFAP?",
        "subtitle": [
          {
            "desc": "FAP y AFAP son causadas por mutaciones en APC y son poco frecuentes (~1/10.000). En FAP pueden aparecer cientos a miles de pólipos en colon y recto desde la adolescencia/temprana adultez. AFAP es más leve y de inicio más tardío, con decenas de pólipos.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué es la mutación APC I1307K?",
        "subtitle": [
          {
            "desc": "APC I1307K no causa FAP; confiere un aumento leve del riesgo de cáncer colorrectal en la adultez. Es común (~7%) en personas de ascendencia judía de Europa del Este (asquenazí). Sinónimos: c.3920T>A, p.Ile1307Lys.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con una mutación en APC?",
        "subtitle": [
          {
            "desc": "Para FAP/AFAP, el manejo del riesgo comienza a edades tempranas y requiere atención por equipos con experiencia. Puede haber otras consideraciones, incluidos riesgos en la infancia.",
            "list": []
          },
          {
            "desc": "Para APC I1307K, pueden indicarse colonoscopías más frecuentes y desde una edad algo más temprana que la población general.",
            "list": []
          },
          {
            "desc": "Si das positivo para una mutación en APC, informa a tus familiares consanguíneos (primer, segundo y tercer grado) y recomiéndales consultar a un experto en genética.",
            "list": []
          }
        ]
      }
    ]

  },

  "BARD1": {
    "title": "BARD1",
    "subtitles": [
      {
        "title": "¿Qué es BARD1?",
        "subtitle": [
          {
            "desc": "BARD1 es un gen que ayuda a reparar el daño del ADN. Las personas que nacen con cambios—llamados mutaciones—en su gen BARD1 tienen un mayor riesgo de cáncer.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Cuáles son los riesgos de cáncer para personas con una mutación en BARD1?",
        "subtitle": [
          {
            "desc": "Las mutaciones en BARD1 se han vinculado con un aumento del riesgo de cáncer de mama en mujeres.",
            "list": ["Cáncer de mama (en mujeres)"]
          },
          {
            "desc": "Actualmente no se cree que aumenten el riesgo de otros cánceres, pero la investigación continúa.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con una mutación en BARD1?",
        "subtitle": [
          {
            "desc": "Existen directrices basadas en la investigación más reciente para el manejo del riesgo de cáncer de mama en mujeres con una mutación BARD1.",
            "list": []
          },
          {
            "desc": "Quienes tienen una mutación BARD1 y ya fueron diagnosticadas con ciertos tipos de cáncer pueden ser candidatas a terapias dirigidas o a ensayos clínicos.",
            "list": []
          },
          {
            "desc": "Si das positivo para una mutación BARD1, informa a tus familiares consanguíneos (primer, segundo y tercer grado) y anímales a hablar con un experto en genética.",
            "list": []
          }
        ]
      }
    ]
  },

  "BRCA1": {
    "title": "BRCA1",
    "subtitles": [
      {
        "title": "¿Qué es BRCA1?",
        "subtitle": [
          {
            "desc": "BRCA1 es un gen que ayuda a reparar el daño del ADN. Las personas que nacen con cambios—llamados mutaciones—en el gen BRCA1 tienen un mayor riesgo de ciertos tipos de cáncer.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué cánceres están asociados con una mutación BRCA1?",
        "subtitle": [
          {
            "desc": "Las personas con una mutación hereditaria en BRCA1 tienen un mayor riesgo de los siguientes cánceres:",
            "list": [
              "Mama",
              "Trompa de Falopio",
              "Ovario",
              "Páncreas",
              "Próstata",
              "Otros (investigación en curso)"
            ]
          }
        ]
      },
      {
        "title": "¿Todas las personas con una mutación BRCA1 desarrollan cáncer?",
        "subtitle": [
          {
            "desc": "Aunque el riesgo de por vida con una mutación BRCA1 es muy alto, no todas las personas con la mutación desarrollan cáncer. Seguir las guías de cribado y prevención aumenta la probabilidad de prevenir el cáncer o detectarlo en etapas más tempranas y tratables.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Los hombres pueden tener una mutación BRCA1?",
        "subtitle": [
          {
            "desc": "Hombres y mujeres pueden portar una mutación BRCA1. Las mutaciones BRCA1 pueden heredarse del padre o de la madre y transmitirse tanto a hijos como a hijas.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Cuáles son las señales de una posible mutación BRCA1 en la familia?",
        "subtitle": [
          {
            "desc": "Algunas señales que pueden indicar una mutación BRCA1 en la familia incluyen:",
            "list": [
              "Cáncer de mama diagnosticado antes de los 50 años.",
              "Cáncer de mama en ambas mamas, o dos diagnósticos separados de cáncer de mama.",
              "Cáncer de mama triple negativo, cáncer de ovario, cáncer de páncreas o cáncer de próstata metastásico a cualquier edad.",
              "Varios familiares del mismo lado de la familia con cáncer de mama, ovario, páncreas o próstata."
            ]
          },
          {
            "desc": "Esta no es una lista completa. Se recomienda hablar con un consejero/a genético para orientar la decisión sobre pruebas genéticas.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Puede BRCA1 saltarse una generación?",
        "subtitle": [
          {
            "desc": "BRCA1 es un gen. Los genes no se saltan generaciones. Cada persona con una mutación BRCA1 tiene un 50% de probabilidad de transmitirla a cada hijo/a. Quienes no heredan la mutación no pueden transmitirla.",
            "list": []
          },
          {
            "desc": "El cáncer puede parecer que “salta” generaciones: algunas personas con la mutación nunca desarrollan cáncer pero sí pueden transmitirla; si su hijo/a hereda la mutación y desarrolla cáncer, puede dar la impresión de salto generacional.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Cómo averiguo si tengo una mutación BRCA1?",
        "subtitle": [
          {
            "desc": "La prueba genética puede identificar mutaciones heredadas en BRCA1 y otros genes. Puede realizarse con sangre, saliva o tejido; la muestra se envía a un laboratorio de pruebas genéticas.",
            "list": []
          },
          {
            "desc": "Es aconsejable hablar con un experto/a en genética antes de la prueba para resolver dudas y asegurar que se solicite el estudio correcto.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Quién debería realizarse la prueba BRCA1?",
        "subtitle": [
          {
            "desc": "Se recomienda consultar sobre prueba genética a:",
            "list": [
              "Cualquier persona con un pariente consanguíneo (primer, segundo o tercer grado) que haya dado positivo a una mutación hereditaria.",
              "Quien tenga antecedentes personales o familiares de cáncer consistentes con las señales listadas arriba."
            ]
          }
        ]
      },
      {
        "title": "¿El seguro cubre el costo de la prueba BRCA1?",
        "subtitle": [
          {
            "desc": "En la mayoría de los casos, el seguro cubre el costo de la prueba genética; pueden aplicar deducibles y copagos según la situación.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Cuánto cuesta la prueba BRCA?",
        "subtitle": [
          {
            "desc": "En muchos casos, la prueba genética cuesta 300 USD o menos; a veces no hay gastos de bolsillo. El costo puede depender de:",
            "list": [
              "Tu cobertura de seguro.",
              "El tipo de prueba genética solicitada.",
              "Tus antecedentes personales y familiares de cáncer."
            ]
          },
          {
            "desc": "Algunos laboratorios ofrecen ayuda financiera a personas con dificultades económicas.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Cuánto demora la prueba BRCA1?",
        "subtitle": [
          {
            "desc": "La muestra (saliva o sangre) puede recogerse en consulta o con un kit enviado a domicilio. Una vez recibido el espécimen por el laboratorio, los resultados suelen estar disponibles en 2 a 6 semanas.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con una mutación BRCA1?",
        "subtitle": [
          {
            "desc": "Existen guías y ensayos clínicos basados en la evidencia que se enfocan en:",
            "list": [
              "Riesgos de cáncer con una mutación BRCA1",
              "Cribado, detección precoz y reducción de riesgo",
              "Tratamiento"
            ]
          },
          {
            "desc": "Estas guías se actualizan anualmente. Quienes dan positivo deben hablar con un experto/a en genética para basar su atención en la información más reciente.",
            "list": []
          },
          {
            "desc": "Si das positivo para una mutación BRCA1, informa a tus familiares consanguíneos (primer, segundo y tercer grado) y anímales a consultar con un experto/a en genética.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué es la anemia de Fanconi y qué relación tiene con BRCA1?",
        "subtitle": [
          {
            "desc": "La anemia de Fanconi (AF) es una enfermedad infantil rara y grave que ocurre cuando un/a niño/a hereda dos mutaciones BRCA1 (una de cada progenitor). Se asocia con problemas hematológicos, alteraciones físicas y del desarrollo, y mayor riesgo de ciertos cánceres.",
            "list": []
          }
        ]
      }
    ]
  },

  "BRCA2": {
    "title": "BRCA2",
    "subtitles": [
      {
        "title": "¿Qué es BRCA2?",
        "subtitle": [
          {
            "desc": "BRCA2 es un gen que ayuda a reparar el daño del ADN. Las personas que nacen con cambios—llamados mutaciones—en el gen BRCA2 tienen un mayor riesgo de ciertos tipos de cáncer.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué tan comunes son las mutaciones BRCA2?",
        "subtitle": [
          {
            "desc": "El número exacto no se conoce, pero se estima que ~1 de cada 400 personas porta una mutación en BRCA2 o en el gen relacionado BRCA1.",
            "list": []
          },
          {
            "desc": "Algunos grupos tienen mayor probabilidad:",
            "list": [
              "≈1 de cada 40 personas de ascendencia judía asquenazí porta una mutación en BRCA1 o BRCA2.",
              "≈1 de cada 250 personas de ascendencia islandesa tiene una mutación en BRCA2."
            ]
          }
        ]
      },
      {
        "title": "¿Qué cánceres están asociados con BRCA2?",
        "subtitle": [
          {
            "desc": "Las personas con una mutación en BRCA2 tienen mayor riesgo de:",
            "list": [
              "Mama",
              "Trompa de Falopio",
              "Ovario",
              "Páncreas",
              "Próstata",
              "Otros (investigación en curso)"
            ]
          }
        ]
      },
      {
        "title": "¿Todas las personas con una mutación BRCA2 desarrollan cáncer?",
        "subtitle": [
          {
            "desc": "Aunque el riesgo de por vida con una mutación BRCA2 es alto, no todas las personas con la mutación desarrollan cáncer. Seguir las guías de cribado y prevención aumenta la probabilidad de prevenirlo o detectarlo en etapas tempranas y tratables.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Los hombres pueden tener una mutación BRCA2?",
        "subtitle": [
          {
            "desc": "Cualquier persona puede portar una mutación BRCA2. Puede heredarse del padre o de la madre y transmitirse tanto a hijos como a hijas.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Cuáles son las señales de una posible mutación BRCA2 en la familia?",
        "subtitle": [
          {
            "desc": "Señales que pueden indicar una mutación BRCA2 en la familia:",
            "list": [
              "Cáncer de mama diagnosticado antes de los 50 años.",
              "Cáncer de mama en ambas mamas o dos diagnósticos separados de cáncer de mama.",
              "Cáncer de mama triple negativo, cáncer de ovario, cáncer de páncreas o cáncer de próstata metastásico a cualquier edad.",
              "Varios familiares del mismo lado de la familia con cáncer de mama, ovario, páncreas o próstata."
            ]
          },
          {
            "desc": "No es una lista completa. Se recomienda hablar con un consejero/a genético para tomar decisiones informadas sobre pruebas genéticas.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Puede BRCA2 saltarse una generación?",
        "subtitle": [
          {
            "desc": "BRCA2 es un gen; los genes no se saltan generaciones. Cada persona con una mutación BRCA2 tiene un 50% de probabilidad de transmitirla a cada hijo/a. Quienes no heredan la mutación no pueden transmitirla.",
            "list": []
          },
          {
            "desc": "El cáncer puede parecer que “salta” generaciones: algunas personas portadoras nunca desarrollan cáncer, pero sí pueden transmitir la mutación; si su hijo/a hereda la mutación y desarrolla cáncer, puede dar la impresión de salto generacional.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Cómo me hago la prueba para una mutación BRCA2?",
        "subtitle": [
          {
            "desc": "La prueba genética puede identificar mutaciones heredadas en BRCA2 y otros genes. Puede realizarse con sangre, saliva o tejido; la muestra se envía a un laboratorio de pruebas genéticas.",
            "list": []
          },
          {
            "desc": "Es aconsejable hablar con un experto/a en genética antes de la prueba para resolver dudas y asegurar que se solicite el estudio correcto.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Quién debería realizarse la prueba BRCA2?",
        "subtitle": [
          {
            "desc": "Deben consultar sobre prueba genética:",
            "list": [
              "Quienes tengan un pariente consanguíneo (primer, segundo o tercer grado) que haya dado positivo a una mutación hereditaria.",
              "Quienes tengan antecedentes personales o familiares de cáncer consistentes con las señales listadas arriba."
            ]
          }
        ]
      },
      {
        "title": "¿El seguro cubre el costo de la prueba BRCA2?",
        "subtitle": [
          {
            "desc": "En la mayoría de las situaciones, el seguro cubre el costo de la prueba genética; pueden aplicar deducibles y copagos según el caso.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Cuánto cuesta la prueba BRCA2?",
        "subtitle": [
          {
            "desc": "En muchos casos, la prueba genética cuesta 300 USD o menos; a veces no hay gastos de bolsillo. El costo puede depender de:",
            "list": [
              "Tu cobertura de seguro.",
              "El tipo de prueba genética solicitada.",
              "Tus antecedentes personales y familiares de cáncer."
            ]
          },
          {
            "desc": "Algunos laboratorios ofrecen asistencia financiera para cubrir el costo en situaciones de dificultad económica.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Cuánto demora la prueba BRCA2?",
        "subtitle": [
          {
            "desc": "La muestra (saliva o sangre) puede recogerse en consulta o con un kit enviado a domicilio. Una vez que el laboratorio recibe la muestra, los resultados suelen estar disponibles en 2 a 6 semanas.",
            "list": []
          }
        ]
      },
      {
        "title": "Di positivo para BRCA2, ¿y ahora qué?",
        "subtitle": [
          {
            "desc": "Existen guías y ensayos clínicos que se enfocan en:",
            "list": [
              "Riesgos de cáncer asociados a una mutación BRCA2",
              "Cribado, detección precoz y reducción de riesgo",
              "Tratamiento"
            ]
          },
          {
            "desc": "Estas guías se actualizan anualmente. Quienes dan positivo deben hablar con un experto/a en genética para basar su atención en la información más reciente.",
            "list": []
          },
          {
            "desc": "Si das positivo para una mutación BRCA2, informa a tus familiares consanguíneos (primer, segundo y tercer grado) y anímales a consultar con un experto/a en genética.",
            "list": []
          }
        ]
      },
      {
        "title": "BRCA2 y anemia de Fanconi",
        "subtitle": [
          {
            "desc": "La anemia de Fanconi (AF) es una enfermedad infantil rara y grave que ocurre cuando un/a niño/a hereda dos mutaciones BRCA2 (una de cada progenitor). Se asocia con problemas hematológicos, alteraciones físicas y del desarrollo, y mayor riesgo de ciertos cánceres.",
            "list": []
          }
        ]
      }
    ]
  },

  "BRIP1": {
    "title": "BRIP1",
    "subtitles": [
      {
        "title": "¿Qué es BRIP1?",
        "subtitle": [
          {
            "desc": "BRIP1 es un gen que ayuda a reparar el daño del ADN. Las personas que nacen con cambios—llamados mutaciones—en su gen BRIP1 tienen un mayor riesgo de ciertos tipos de cáncer.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué cánceres están asociados con una mutación BRIP1?",
        "subtitle": [
          {
            "desc": "Las mutaciones en BRIP1 se han vinculado con un aumento del riesgo de los siguientes cánceres:",
            "list": ["Trompa de Falopio", "Ovario"]
          },
          {
            "desc": "Se está investigando si estas mutaciones aumentan el riesgo de otros cánceres.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Todas las personas con una mutación BRIP1 desarrollan cáncer?",
        "subtitle": [
          {
            "desc": "Aunque el riesgo de por vida con una mutación BRIP1 es más alto que el promedio, no todas las personas con la mutación desarrollarán cáncer. Seguir las recomendaciones de manejo del riesgo puede ayudar a evitar un diagnóstico de cáncer.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con una mutación BRIP1?",
        "subtitle": [
          {
            "desc": "Existen guías de expertos con recomendaciones para gestionar el riesgo de cáncer en personas con mutación BRIP1.",
            "list": []
          },
          {
            "desc": "Quienes tengan una mutación BRIP1 y hayan sido diagnosticadas con ciertos tipos de cáncer pueden ser candidatas a terapias dirigidas o a ensayos clínicos.",
            "list": []
          },
          {
            "desc": "Informa a tus familiares consanguíneos (primer, segundo y tercer grado) sobre tu resultado y anímales a hablar con un/a experto/a en genética.",
            "list": []
          }
        ]
      },
      {
        "title": "Otras consideraciones médicas",
        "subtitle": [
          {
            "desc": "La anemia de Fanconi es una enfermedad infantil rara que puede ocurrir cuando se hereda una mutación en ambas copias del gen BRIP1.",
            "list": []
          }
        ]
      }
    ]

  },

  "CDH1": {
    "title": "CDH1",
    "subtitles": [
      {
        "title": "¿Qué es CDH1?",
        "subtitle": [
          {
            "desc": "CDH1 es un gen que ayuda a controlar el crecimiento celular. Las personas que nacen con mutaciones en CDH1 tienen un mayor riesgo de ciertos tipos de cáncer.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué cánceres están asociados con una mutación CDH1?",
        "subtitle": [
          {
            "desc": "Una mutación hereditaria en CDH1 se asocia con mayor riesgo de:",
            "list": ["Cáncer de mama", "Cáncer gástrico difuso"]
          }
        ]
      },
      {
        "title": "¿Qué es el cáncer gástrico difuso hereditario (HDGC)?",
        "subtitle": [
          {
            "desc": "El HDGC es un tipo raro de cáncer de estómago (≈1%–3% de los cánceres gástricos). Puede ser causado por una mutación hereditaria en CDH1 o en el gen relacionado CTNNA1.",
            "list": []
          },
          {
            "desc": "Es difícil de detectar en etapas tempranas por su patrón de crecimiento: las células anormales se diseminan bajo el revestimiento del estómago y no forman una masa visible. La endoscopia alta puede verse normal, por lo que a menudo se diagnostica en etapas avanzadas.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Todas las personas con una mutación CDH1 desarrollan cáncer?",
        "subtitle": [
          {
            "desc": "Aunque el riesgo de por vida con una mutación CDH1 es alto, no todas las personas con la mutación desarrollarán cáncer. Seguir las guías de cribado y prevención mejora las probabilidades de prevenirlo o detectarlo tempranamente.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con una mutación CDH1?",
        "subtitle": [
          {
            "desc": "Existen guías de expertos que estiman el riesgo y recomiendan estrategias de manejo para personas con mutación CDH1.",
            "list": []
          },
          {
            "desc": "Informa a tus familiares consanguíneos (primer, segundo y tercer grado) sobre tu resultado y anímales a consultar a un/a experto/a en genética.",
            "list": []
          }
        ]
      },
      {
        "title": "Otras consideraciones médicas",
        "subtitle": [
          {
            "desc": "El síndrome blefarocheilodóntico (BCD) es una enfermedad infantil rara relacionada con CDH1 que puede causar fisura labial y/o palatina y alteraciones en los párpados.",
            "list": []
          }
        ]
      }
    ]
  },

  "CDKN2A": {
    "title": "CDKN2A",
    "subtitles": [
      {
        "title": "¿Qué es CDKN2A?",
        "subtitle": [
          {
            "desc": "CDKN2A es un gen que ayuda a controlar el crecimiento celular. Las personas que nacen con mutaciones en CDKN2A tienen un mayor riesgo de ciertos tipos de cáncer.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué cánceres están asociados con una mutación CDKN2A?",
        "subtitle": [
          {
            "desc": "Las mutaciones hereditarias en CDKN2A causan el síndrome de melanoma múltiple atípico familiar (FAMMM) y aumentan el riesgo de:",
            "list": ["Melanoma", "Cáncer de páncreas"]
          },
          {
            "desc": "Un pequeño número de mutaciones en CDKN2A también puede aumentar el riesgo de tumores de vaina nerviosa, sarcomas y otros cánceres.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Todas las personas con una mutación CDKN2A desarrollan cáncer?",
        "subtitle": [
          {
            "desc": "Aunque el riesgo de por vida con una mutación CDKN2A es alto, no todas las personas con la mutación desarrollarán cáncer. Seguir las guías de cribado y prevención mejora las probabilidades de prevenirlo o detectarlo tempranamente.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con una mutación CDKN2A?",
        "subtitle": [
          {
            "desc": "Existen guías de expertos que estiman los riesgos y recomiendan estrategias de manejo para personas con mutación CDKN2A.",
            "list": []
          },
          {
            "desc": "Puede haber consideraciones y opciones de planificación familiar para personas con una mutación hereditaria en CDKN2A.",
            "list": []
          },
          {
            "desc": "Informa a tus familiares consanguíneos (primer, segundo y tercer grado) sobre tu resultado y anímales a consultar a un/a experto/a en genética.",
            "list": []
          }
        ]
      }
    ]
  }
  ,

  "CDK4": {
    "title": "CDK4",
    "subtitles": [
      {
        "title": "¿Qué es CDK4?",
        "subtitle": [
          {
            "desc": "CDK4 es un gen que ayuda a controlar el crecimiento celular. Las personas que nacen con mutaciones en CDK4 tienen un mayor riesgo de ciertos tipos de cáncer.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué riesgos de cáncer se asocian con una mutación CDK4?",
        "subtitle": [
          {
            "desc": "Una mutación hereditaria en CDK4 se asocia con mayor riesgo de:",
            "list": ["Melanoma", "Posiblemente cáncer de páncreas"]
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con una mutación CDK4?",
        "subtitle": [
          {
            "desc": "Existen guías de expertos con recomendaciones para gestionar el riesgo en personas con mutación CDK4. También puede haber consideraciones y opciones de planificación familiar.",
            "list": []
          },
          {
            "desc": "Informa a tus familiares consanguíneos (primer, segundo y tercer grado) sobre tu resultado y anímales a hablar con un/a experto/a en genética.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Todas las personas con una mutación CDK4 desarrollan cáncer?",
        "subtitle": [
          {
            "desc": "Aunque el riesgo de por vida con una mutación CDK4 puede ser alto, no todas las personas con la mutación desarrollarán cáncer. Seguir las guías de cribado y prevención aumenta las probabilidades de prevenirlo o detectarlo en etapas tempranas y tratables.",
            "list": []
          }
        ]
      }
    ]
  },

  "CHEK2": {
    "title": "CHEK2",
    "subtitles": [
      {
        "title": "¿Qué es CHEK2?",
        "subtitle": [
          {
            "desc": "CHEK2 es un gen que ayuda a reparar el daño del ADN. Las personas que nacen con cambios—llamados mutaciones—en el gen CHEK2 tienen un mayor riesgo de ciertos tipos de cáncer.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué cánceres están asociados con una mutación CHEK2?",
        "subtitle": [
          {
            "desc": "Las personas con una mutación hereditaria en CHEK2 tienen un mayor riesgo de ciertos cánceres, entre ellos:",
            "list": [
              "Cáncer de mama en mujeres",
              "Cáncer de mama en hombres"
            ]
          },
          {
            "desc": "Las mutaciones en CHEK2 también se han vinculado con un mayor riesgo de cáncer de próstata y otros cánceres, pero se necesita más investigación para confirmarlo.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Todas las personas con una mutación CHEK2 desarrollan cáncer?",
        "subtitle": [
          {
            "desc": "Aunque el riesgo de por vida con una mutación CHEK2 es mayor que el promedio, no todas las personas con la mutación desarrollarán cáncer. Seguir las guías de cribado y prevención aumenta la probabilidad de prevenirlo o detectarlo en etapas tempranas y tratables.",
            "list": []
          }
        ]
      },
      {
        "title": "Opciones si das positivo para una mutación CHEK2",
        "subtitle": [
          {
            "desc": "Existen guías y ensayos clínicos que se enfocan en:",
            "list": [
              "Cribado y detección precoz",
              "Reducción de riesgo",
              "Tratamiento"
            ]
          },
          {
            "desc": "Las guías se actualizan anualmente. Habla con un/a experto/a en genética para asegurarte de que tu atención esté basada en la información más reciente.",
            "list": []
          },
          {
            "desc": "Si das positivo para una mutación CHEK2, informa a tus familiares consanguíneos (primer, segundo y tercer grado) y anímales a hablar con un/a experto/a en genética.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Pueden las mutaciones CHEK2 saltarse una generación?",
        "subtitle": [
          {
            "desc": "Las mutaciones CHEK2 se transmiten de padres a hijos, pero no se “saltan” generaciones. Cada persona con una mutación CHEK2 tiene un 50% de probabilidad de transmitirla a cada hijo/a. Quienes no heredan la mutación no pueden transmitirla.",
            "list": []
          },
          {
            "desc": "Las personas con una mutación CHEK2 que nunca desarrollan cáncer aún pueden transmitirla. Si un/a hijo/a hereda la mutación y desarrolla cáncer, puede parecer que la mutación se ‘saltó’ una generación.",
            "list": []
          }
        ]
      }
    ]
  },

  "EPCAM": {
    "title": "EPCAM",
    "subtitles": [
      {
        "title": "¿Qué es una mutación en EPCAM?",
        "subtitle": [
          {
            "desc": "EPCAM es un gen cuyas mutaciones hereditarias causan el síndrome de Lynch. Las personas con síndrome de Lynch tienen mayor riesgo de varios tipos de cáncer. Otros nombres incluyen cáncer colorrectal hereditario no polipósico (HNPCC) y síndrome de Muir-Torre (un subconjunto con riesgo de tumores cutáneos poco frecuentes).",
            "list": []
          },
          {
            "desc": "Las mutaciones en EPCAM causan síndrome de Lynch afectando a un gen cercano llamado MSH2, también vinculado a Lynch. Los riesgos y las recomendaciones de manejo son similares para mutaciones en EPCAM o MSH2.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué cánceres están asociados con una mutación EPCAM?",
        "subtitle": [
          {
            "desc": "Las personas con una mutación hereditaria en EPCAM tienen un mayor riesgo de múltiples cánceres, especialmente:",
            "list": [
              "Intestino grueso (colon y recto)",
              "Útero (endometrio)"
            ]
          },
          {
            "desc": "Las guías de expertos incluyen estimaciones de riesgo de por vida para personas con mutaciones en EPCAM y se actualizan anualmente según nueva investigación.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Todas las personas con una mutación EPCAM desarrollan cáncer?",
        "subtitle": [
          {
            "desc": "Aunque el riesgo de por vida puede ser muy alto, no todas las personas con la mutación desarrollarán cáncer. Seguir las guías de cribado y prevención aumenta la probabilidad de prevenirlo o detectarlo tempranamente.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Pueden las mutaciones EPCAM saltarse una generación?",
        "subtitle": [
          {
            "desc": "Las mutaciones EPCAM se heredan, pero no se ‘saltan’ generaciones. Cada persona portadora tiene un 50% de probabilidad de transmitirla a cada hijo/a. Quienes no heredan la mutación no pueden transmitirla.",
            "list": []
          },
          {
            "desc": "Las personas portadoras que nunca desarrollan cáncer aún pueden transmitir la mutación; si su descendencia desarrolla cáncer, puede parecer un ‘salto’ generacional.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con una mutación EPCAM?",
        "subtitle": [
          {
            "desc": "Hay opciones de cribado, prevención y tratamiento del cáncer hereditario. Existen guías y ensayos clínicos que se enfocan en cribado/detección precoz, reducción de riesgo y tratamiento.",
            "list": []
          },
          {
            "desc": "Puede haber otras consideraciones médicas, incluido el déficit constitucional de reparación de apareamientos erróneos (CMMRD), una enfermedad infantil rara que ocurre cuando se heredan mutaciones en ambas copias del gen implicado.",
            "list": []
          },
          {
            "desc": "Si das positivo para una mutación EPCAM, informa a tus familiares consanguíneos (primer, segundo y tercer grado) y anímales a hablar con un/a experto/a en genética.",
            "list": []
          }
        ]
      }
    ]
  },

  "HOXB13": {
    "title": "HOXB13",
    "subtitles": [
      {
        "title": "¿Qué es HOXB13?",
        "subtitle": [
          {
            "desc": "HOXB13 es un gen que ayuda a controlar el crecimiento celular. Las personas que nacen con mutaciones en HOXB13 tienen un mayor riesgo de ciertos tipos de cáncer.",
            "list": []
          }
        ]
      },
      {
        "title": "Riesgos de cáncer asociados a HOXB13",
        "subtitle": [
          {
            "desc": "Las mutaciones en HOXB13 se han vinculado con un aumento del riesgo de cáncer de próstata.",
            "list": []
          },
          {
            "desc": "No hay suficiente investigación para concluir que una mutación HOXB13 aumente el riesgo de otros cánceres.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con una mutación HOXB13?",
        "subtitle": [
          {
            "desc": "Existen guías para el cribado de cáncer de próstata en personas con mutaciones HOXB13.",
            "list": []
          },
          {
            "desc": "Quienes tengan una mutación HOXB13 y hayan sido diagnosticados con cáncer pueden ser candidatos a tratamientos específicos o ensayos clínicos.",
            "list": []
          },
          {
            "desc": "Si das positivo para una mutación HOXB13, informa a tus familiares consanguíneos y anímales a consultar con un/a experto/a en genética.",
            "list": []
          }
        ]
      }
    ]
  },

  "MLH1": {
    "title": "MLH1",
    "subtitles": [
      {
        "title": "¿Qué es una mutación en MLH1?",
        "subtitle": [
          {
            "desc": "MLH1 es un gen que ayuda a reparar el daño del ADN. Las mutaciones hereditarias en MLH1 causan el síndrome de Lynch. Las personas con Lynch tienen mayor riesgo de varios tipos de cáncer.",
            "list": []
          },
          {
            "desc": "Otros nombres para el síndrome de Lynch incluyen cáncer colorrectal hereditario no polipósico (HNPCC) y síndrome de Muir-Torre (subconjunto con mayor riesgo de tumores cutáneos poco frecuentes).",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué cánceres están asociados con una mutación MLH1?",
        "subtitle": [
          {
            "desc": "Las personas con una mutación MLH1 tienen mayor riesgo de muchos cánceres, con especial énfasis en:",
            "list": [
              "Intestino grueso (colon y recto)",
              "Útero (endometrio)"
            ]
          },
          {
            "desc": "Las guías de expertos incluyen estimaciones de riesgo de por vida para mutaciones MLH1.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Todas las personas con una mutación MLH1 desarrollan cáncer?",
        "subtitle": [
          {
            "desc": "Aunque el riesgo de por vida con una mutación MLH1 puede ser muy alto, no todas las personas con la mutación desarrollarán cáncer. Seguir las guías de cribado y prevención mejora las probabilidades de prevenirlo o detectarlo tempranamente.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Pueden las mutaciones MLH1 saltarse una generación?",
        "subtitle": [
          {
            "desc": "Las mutaciones MLH1 se transmiten de padres a hijos, pero no se ‘saltan’ generaciones. Cada persona portadora tiene un 50% de probabilidad de transmitirla a cada hijo/a. Quienes no heredan la mutación no pueden transmitirla.",
            "list": []
          },
          {
            "desc": "Las personas portadoras que nunca desarrollan cáncer aún pueden transmitir la mutación; si su descendencia desarrolla cáncer, puede parecer un ‘salto’ generacional.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con una mutación MLH1?",
        "subtitle": [
          {
            "desc": "Hay opciones de cribado, prevención y tratamiento del cáncer hereditario. Existen guías y ensayos clínicos que se enfocan en cribado/detección precoz, reducción de riesgo y tratamiento. Se actualizan anualmente con nueva evidencia.",
            "list": []
          },
          {
            "desc": "Puede haber otras consideraciones médicas, incluido el déficit constitucional de reparación de apareamientos erróneos (CMMRD), una enfermedad infantil rara que ocurre cuando se heredan mutaciones en ambas copias del gen.",
            "list": []
          },
          {
            "desc": "Si das positivo para una mutación MLH1, informa a tus familiares consanguíneos (primer, segundo y tercer grado) y anímales a hablar con un/a experto/a en genética.",
            "list": []
          }
        ]
      }
    ]
  }
  ,

  "MSH2": {
    "title": "MSH2",
    "subtitles": [
      {
        "title": "¿Qué es una mutación en MSH2?",
        "subtitle": [
          {
            "desc": "MSH2 es un gen que ayuda a reparar el daño del ADN. Las mutaciones hereditarias en MSH2 causan el síndrome de Lynch, que aumenta el riesgo de varios tipos de cáncer.",
            "list": []
          },
          {
            "desc": "Otros nombres para Lynch incluyen cáncer colorrectal hereditario no polipósico (HNPCC) y síndrome de Muir-Torre (subconjunto con riesgo de tumores cutáneos poco frecuentes).",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué cánceres están asociados con una mutación MSH2?",
        "subtitle": [
          {
            "desc": "Las personas con una mutación MSH2 tienen mayor riesgo de muchos cánceres, especialmente:",
            "list": [
              "Intestino grueso (colon y recto)",
              "Útero (endometrio)"
            ]
          },
          {
            "desc": "Las guías de expertos incluyen estimaciones de riesgo de por vida para personas con mutaciones MSH2.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Todas las personas con una mutación MSH2 desarrollan cáncer?",
        "subtitle": [
          {
            "desc": "Aunque el riesgo de por vida con una mutación MSH2 puede ser muy alto, no todas las personas con la mutación desarrollarán cáncer. Seguir las guías de cribado y prevención aumenta la probabilidad de prevenirlo o detectarlo tempranamente.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Pueden las mutaciones MSH2 saltarse una generación?",
        "subtitle": [
          {
            "desc": "Las mutaciones MSH2 se heredan, pero no se ‘saltan’ generaciones. Cada persona portadora tiene un 50% de probabilidad de transmitirla a cada hijo/a. Quienes no heredan la mutación no pueden transmitirla.",
            "list": []
          },
          {
            "desc": "Las personas portadoras que nunca desarrollan cáncer aún pueden transmitir la mutación; si su descendencia desarrolla cáncer, puede parecer un ‘salto’ generacional.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con una mutación MSH2?",
        "subtitle": [
          {
            "desc": "Hay opciones de cribado, prevención y tratamiento del cáncer hereditario. Existen guías y ensayos clínicos que se enfocan en cribado/detección precoz, reducción de riesgo y tratamiento.",
            "list": []
          },
          {
            "desc": "Puede haber otras consideraciones médicas, incluido el déficit constitucional de reparación de apareamientos erróneos (CMMRD), una enfermedad infantil rara que ocurre cuando se heredan mutaciones en ambas copias del gen.",
            "list": []
          },
          {
            "desc": "Si das positivo para una mutación MSH2, informa a tus familiares consanguíneos (primer, segundo y tercer grado) y anímales a hablar con un/a experto/a en genética.",
            "list": []
          }
        ]
      }
    ]
  },

  "MSH6": {
    "title": "MSH6",
    "subtitles": [
      {
        "title": "¿Qué es una mutación en MSH6?",
        "subtitle": [
          {
            "desc": "MSH6 es un gen que ayuda a reparar el daño del ADN. Las mutaciones hereditarias en MSH6 causan el síndrome de Lynch, que incrementa el riesgo de varios tipos de cáncer.",
            "list": []
          },
          {
            "desc": "Otros nombres relacionados con el síndrome de Lynch:",
            "list": [
              "Cáncer colorrectal hereditario no polipósico (HNPCC)",
              "Síndrome de Muir-Torre (subconjunto con mayor riesgo de tumores cutáneos raros)"
            ]
          }
        ]
      },
      {
        "title": "¿Qué cánceres están asociados con una mutación MSH6?",
        "subtitle": [
          {
            "desc": "Las personas con una mutación hereditaria en MSH6 tienen un mayor riesgo de muchos cánceres, especialmente:",
            "list": [
              "Intestino grueso (colon y recto)",
              "Útero (endometrio)"
            ]
          },
          {
            "desc": "Las guías de expertos incluyen estimaciones de riesgo de por vida para personas con mutaciones MSH6.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Todas las personas con una mutación MSH6 desarrollan cáncer?",
        "subtitle": [
          {
            "desc": "Aunque el riesgo de por vida puede ser muy alto, no todas las personas con la mutación desarrollarán cáncer. Seguir las guías de cribado y prevención aumenta la probabilidad de prevenirlo o detectarlo en etapas más tempranas y tratables.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Pueden las mutaciones MSH6 saltarse una generación?",
        "subtitle": [
          {
            "desc": "Las mutaciones MSH6 se heredan, pero no se ‘saltan’ generaciones. Cada persona con la mutación tiene un 50% de probabilidad de transmitirla a cada hijo/a. Quienes no la heredan no pueden transmitirla.",
            "list": []
          },
          {
            "desc": "Portadores que nunca desarrollan cáncer aún pueden transmitir la mutación; si su descendencia desarrolla cáncer, puede parecer que ‘se saltó’ una generación.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con una mutación MSH6?",
        "subtitle": [
          {
            "desc": "Opciones basadas en guías y ensayos clínicos:",
            "list": [
              "Cribado y detección precoz",
              "Reducción de riesgo",
              "Tratamiento"
            ]
          },
          {
            "desc": "Otras consideraciones médicas: el déficit constitucional de reparación de errores de apareamiento (CMMRD) puede ocurrir cuando se heredan mutaciones en ambas copias del gen MSH6.",
            "list": []
          },
          {
            "desc": "Si das positivo, informa a familiares consanguíneos (primer, segundo y tercer grado) y anímales a consultar con un/a experto/a en genética.",
            "list": []
          }
        ]
      }
    ]
  },

  "MUTYH": {
    "title": "MUTYH",
    "subtitles": [
      {
        "title": "¿Qué es MUTYH?",
        "subtitle": [
          {
            "desc": "MUTYH es un gen asociado a un incremento del riesgo de cáncer en ciertos contextos hereditarios.",
            "list": []
          }
        ]
      },
      {
        "title": "Riesgos de cáncer en personas con mutaciones MUTYH",
        "subtitle": [
          {
            "desc": "Mutaciones en ambas copias de MUTYH (bialélicas) causan la poliposis asociada a MUTYH (MAP), con alto riesgo de varios cánceres desde edades tempranas.",
            "list": ["Poliposis asociada a MUTYH (MAP)"]
          },
          {
            "desc": "Las personas con mutación en una sola copia de MUTYH (monoalélicas) no desarrollan MAP y no se consideran de mayor riesgo para cáncer colorrectal.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con una mutación MUTYH?",
        "subtitle": [
          {
            "desc": "Existen guías para cribado y prevención en personas con MAP (mutaciones en ambas copias).",
            "list": []
          },
          {
            "desc": "Quienes tienen MAP y han sido diagnosticados con cáncer pueden ser candidatos a tratamientos específicos o ensayos clínicos.",
            "list": []
          },
          {
            "desc": "Dado el alto riesgo de por vida, las personas en edad reproductiva con MAP pueden consultar opciones de planificación familiar con un/a experto/a en genética.",
            "list": []
          }
        ]
      }
    ]
  },

  "NBN": {
    "title": "NBN",
    "subtitles": [
      {
        "title": "¿Qué es NBN?",
        "subtitle": [
          {
            "desc": "NBN es un gen que ayuda a reparar el daño del ADN. Las personas nacidas con una mutación en una sola copia del gen NBN no se consideran de mayor riesgo de cáncer.",
            "list": []
          }
        ]
      },
      {
        "title": "Conexión entre mutaciones NBN y cáncer",
        "subtitle": [
          {
            "desc": "Quienes tienen una sola mutación en NBN presentan un riesgo similar al de la población general. En personas ya diagnosticadas con cáncer, una mutación NBN puede abrir opciones terapéuticas.",
            "list": []
          },
          {
            "desc": "Quienes heredan mutaciones en ambas copias de NBN desarrollan el síndrome de rotura de Nijmegen, asociado a condiciones del desarrollo y mayor riesgo de linfomas y otros cánceres.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con una mutación NBN?",
        "subtitle": [
          {
            "desc": "Si das positivo para una mutación NBN, consulta con un/a experto/a en genética para asegurar que tu atención se base en la evidencia más actualizada.",
            "list": []
          }
        ]
      }
    ]
  },

  "PALB2": {
    "title": "PALB2",
    "subtitles": [
      {
        "title": "¿Qué es PALB2?",
        "subtitle": [
          {
            "desc": "PALB2 es un gen que ayuda a reparar el daño del ADN. Las personas que nacen con mutaciones en PALB2 tienen un mayor riesgo de ciertos tipos de cáncer.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué cánceres están asociados con una mutación PALB2?",
        "subtitle": [
          {
            "desc": "Las personas con una mutación hereditaria en PALB2 tienen riesgo aumentado de:",
            "list": [
              "Mama",
              "Trompa de Falopio",
              "Ovario",
              "Páncreas",
              "Próstata (se necesita más investigación para confirmarlo)"
            ]
          }
        ]
      },
      {
        "title": "¿Todas las personas con una mutación PALB2 desarrollan cáncer?",
        "subtitle": [
          {
            "desc": "Aunque el riesgo de por vida se incrementa, no todas las personas con PALB2 desarrollarán cáncer. Seguir las guías de cribado y prevención aumenta la probabilidad de prevenirlo o detectarlo tempranamente.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Los hombres pueden tener una mutación PALB2?",
        "subtitle": [
          {
            "desc": "Hombres y mujeres pueden portar una mutación PALB2. Puede heredarse del padre o de la madre y transmitirse a hijos e hijas.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Puede PALB2 saltarse una generación?",
        "subtitle": [
          {
            "desc": "PALB2 es un gen; los genes no se ‘saltan’ generaciones. Cada persona con la mutación tiene un 50% de probabilidad de transmitirla a cada hijo/a. Quienes no la heredan no pueden transmitirla.",
            "list": []
          },
          {
            "desc": "El cáncer puede parecer que ‘salta’ generaciones porque algunas personas con la mutación nunca desarrollan cáncer pero pueden transmitirla; si su descendencia desarrolla cáncer, da la impresión de salto.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Cómo averiguo si tengo una mutación PALB2?",
        "subtitle": [
          {
            "desc": "La prueba genética (sangre, saliva o tejido) puede identificar mutaciones heredadas en PALB2 y otros genes. La muestra se envía a un laboratorio genético.",
            "list": []
          },
          {
            "desc": "Es recomendable hablar con un/a experto/a en genética antes de la prueba para resolver dudas y solicitar el estudio adecuado.",
            "list": []
          }
        ]
      },
      {
        "title": "Cobertura y costo de la prueba PALB2",
        "subtitle": [
          {
            "desc": "En la mayoría de los casos, el seguro cubre el costo; pueden aplicar deducibles y copagos.",
            "list": []
          },
          {
            "desc": "Frecuentemente el costo es de 300 USD o menos; en ciertas situaciones puede no haber gasto de bolsillo. Factores que influyen:",
            "list": [
              "Cobertura de seguro",
              "Tipo de prueba solicitada",
              "Antecedentes personales y familiares de cáncer"
            ]
          },
          {
            "desc": "Algunos laboratorios ofrecen asistencia financiera en casos de dificultad económica.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con una mutación PALB2?",
        "subtitle": [
          {
            "desc": "Guías y ensayos clínicos se enfocan en:",
            "list": [
              "Riesgos de cáncer",
              "Cribado, detección precoz y reducción de riesgo",
              "Tratamiento"
            ]
          },
          {
            "desc": "Estas guías se actualizan anualmente. Consulta con un/a experto/a en genética para atención basada en la evidencia más reciente e informa a familiares consanguíneos (primer, segundo y tercer grado).",
            "list": []
          }
        ]
      },
      {
        "title": "Anemia de Fanconi y PALB2",
        "subtitle": [
          {
            "desc": "La anemia de Fanconi (AF) es una enfermedad infantil rara y grave que ocurre cuando un/a niño/a hereda dos mutaciones PALB2 (una de cada progenitor), asociada a problemas hematológicos, físicos y del desarrollo y mayor riesgo de ciertos cánceres.",
            "list": []
          }
        ]
      }
    ]

  },

  "PMS2": {
    "title": "PMS2",
    "subtitles": [
      {
        "title": "¿Qué es una mutación en PMS2?",
        "subtitle": [
          {
            "desc": "PMS2 es un gen que ayuda a reparar el daño del ADN. Las mutaciones hereditarias en PMS2 causan el síndrome de Lynch.",
            "list": []
          },
          {
            "desc": "Otros nombres para el síndrome de Lynch:",
            "list": [
              "Cáncer colorrectal hereditario no polipósico (HNPCC)",
              "Síndrome de Muir-Torre (subconjunto con mayor riesgo de tumores cutáneos raros)"
            ]
          }
        ]
      },
      {
        "title": "¿Qué cánceres están asociados con una mutación PMS2?",
        "subtitle": [
          {
            "desc": "Mayor riesgo de múltiples cánceres, especialmente:",
            "list": [
              "Intestino grueso (colon y recto)",
              "Útero (endometrio)"
            ]
          },
          {
            "desc": "Las guías de expertos incluyen estimaciones de riesgo de por vida para personas con mutaciones en PMS2.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Todas las personas con una mutación PMS2 desarrollan cáncer?",
        "subtitle": [
          {
            "desc": "Aunque el riesgo de por vida puede ser alto, no todas las personas con la mutación desarrollarán cáncer. Seguir las guías de cribado y prevención aumenta la probabilidad de prevenirlo o detectarlo tempranamente.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Pueden las mutaciones PMS2 saltarse una generación?",
        "subtitle": [
          {
            "desc": "PMS2 es un gen; los genes no se ‘saltan’ generaciones. Cada persona con la mutación tiene un 50% de probabilidad de transmitirla a cada hijo/a. Quienes no la heredan no pueden transmitirla.",
            "list": []
          },
          {
            "desc": "El cáncer puede parecer que ‘salta’ generaciones cuando un portador nunca enferma pero su descendencia sí.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con una mutación PMS2?",
        "subtitle": [
          {
            "desc": "Opciones basadas en guías y ensayos clínicos:",
            "list": [
              "Cribado y detección precoz",
              "Reducción de riesgo",
              "Tratamiento"
            ]
          },
          {
            "desc": "Otras consideraciones médicas: el CMMRD (déficit constitucional de reparación de errores de apareamiento) puede ocurrir cuando se heredan mutaciones en ambas copias del gen PMS2.",
            "list": []
          },
          {
            "desc": "Informa a familiares consanguíneos (primer, segundo y tercer grado) y anímales a consultar con un/a experto/a en genética.",
            "list": []
          }
        ]
      }
    ]

  },

  "PTEN": {
    "title": "PTEN (síndrome de tumores hamartomatosos por PTEN / PHTS, también llamado síndrome de Cowden)",
    "subtitles": [
      {
        "title": "¿Qué es PTEN y el síndrome de Cowden?",
        "subtitle": [
          {
            "desc": "PTEN es un gen; las personas con mutaciones hereditarias en PTEN tienen el síndrome de tumores hamartomatosos por PTEN (PHTS), también conocido como síndrome de Cowden, con mayor riesgo de varios tipos de cáncer.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Todas las personas con una mutación heredada de PTEN desarrollan cáncer?",
        "subtitle": [
          {
            "desc": "Aunque el riesgo de por vida es alto, no todas las personas con la mutación desarrollarán cáncer. Seguir las guías de cribado y prevención aumenta la probabilidad de prevenirlo o detectarlo en etapas tempranas.",
            "list": []
          }
        ]
      },
      {
        "title": "Mi tumor tiene una mutación PTEN, ¿significa que tengo PHTS/Cowden?",
        "subtitle": [
          {
            "desc": "No necesariamente. Las mutaciones encontradas solo en células tumorales se denominan somáticas y no implican PHTS.",
            "list": []
          },
          {
            "desc": "Pruebas en tumores (biomarcadores): identifican mutaciones para orientar tratamiento. Las mutaciones somáticas en PTEN son frecuentes en varios tumores; su presencia no significa que tengas una mutación hereditaria.",
            "list": []
          }
        ]
      },
      {
        "title": "Mutaciones germinales y de novo en PTEN",
        "subtitle": [
          {
            "desc": "Mutaciones germinales (heredadas): están en todas las células del cuerpo y causan PHTS/Cowden. La prueba genética evalúa mutaciones heredadas en PTEN.",
            "list": []
          },
          {
            "desc": "Mutaciones de novo: algunas personas son las primeras en su familia con PHTS. Dependiendo del momento en el desarrollo, la mutación puede o no estar en todas las células; si está en óvulos o espermatozoides, puede transmitirse a la descendencia.",
            "list": []
          }
        ]
      },
      {
        "title": "Signos de una mutación heredada en PTEN / PHTS / Cowden",
        "subtitle": [
          {
            "desc": "No todas las familias presentan todos los signos. Consulta con un/a experto/a en genética si sospechas PHTS. Algunos signos incluyen:",
            "list": [
              "Cáncer de mama, endometrio o tiroides",
              "Hamartomas múltiples en el tracto gastrointestinal",
              "Múltiples lesiones en boca o cara",
              "Zonas de piel engrosada en manos o pies",
              "Macrocefalia (tamaño de cabeza mayor)"
            ]
          }
        ]
      },
      {
        "title": "¿Cómo saber si tengo una mutación PTEN?",
        "subtitle": [
          {
            "desc": "La prueba genética (sangre, saliva o tejido) puede identificar una mutación heredada en PTEN; la muestra se envía a un laboratorio de genética.",
            "list": []
          },
          {
            "desc": "Habla con un/a experto/a en genética antes de la prueba para aclarar dudas y asegurar que se solicite el estudio correcto.",
            "list": []
          }
        ]
      },
      {
        "title": "Riesgos de cáncer en personas con una mutación PTEN",
        "subtitle": [
          {
            "desc": "Riesgo elevado de varios cánceres, entre ellos:",
            "list": [
              "Mama",
              "Endometrio",
              "Riñón",
              "Tiroides",
              "Colorrectal",
              "Otros"
            ]
          },
          {
            "desc": "Los riesgos pueden iniciar a edades tempranas.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con PHTS o síndrome de Cowden?",
        "subtitle": [
          {
            "desc": "Opciones basadas en guías y ensayos clínicos:",
            "list": [
              "Riesgos de cáncer",
              "Cribado, detección precoz y reducción de riesgo",
              "Tratamiento oncológico"
            ]
          },
          {
            "desc": "Estas guías se actualizan anualmente. Consulta con un/a experto/a en genética para una atención basada en la evidencia más reciente.",
            "list": []
          },
          {
            "desc": "Puede haber otras consideraciones médicas, incluidos riesgos oncológicos en la infancia. Informa a tus familiares consanguíneos (primer, segundo y tercer grado).",
            "list": []
          }
        ]
      }
    ]

  },

  "RAD51C": {
    "title": "RAD51C",
    "subtitles": [
      {
        "title": "¿Qué es RAD51C?",
        "subtitle": [
          {
            "desc": "RAD51C es un gen que ayuda a reparar el daño del ADN. Las personas con mutaciones en RAD51C tienen un mayor riesgo de algunos tipos de cáncer.",
            "list": []
          }
        ]
      },
      {
        "title": "Riesgos de cáncer en personas con mutación RAD51C",
        "subtitle": [
          {
            "desc": "Se han vinculado con riesgo incrementado de:",
            "list": ["Mama", "Trompa de Falopio", "Ovario"]
          },
          {
            "desc": "Se investiga si estas mutaciones aumentan el riesgo de otros cánceres.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con una mutación RAD51C?",
        "subtitle": [
          {
            "desc": "Opciones basadas en guías y ensayos clínicos:",
            "list": [
              "Riesgos de cáncer",
              "Cribado, detección precoz y reducción de riesgo",
              "Tratamiento"
            ]
          },
          {
            "desc": "Si das positivo, informa a tus familiares consanguíneos (primer, segundo y tercer grado) y consulta con un/a experto/a en genética.",
            "list": []
          }
        ]
      }
    ]

  },

  "RAD51D": {
    "title": "RAD51D",
    "subtitles": [
      {
        "title": "¿Qué es RAD51D?",
        "subtitle": [
          {
            "desc": "RAD51D es un gen que ayuda a reparar el daño del ADN. Las personas con mutaciones en RAD51D tienen un mayor riesgo de algunos tipos de cáncer.",
            "list": []
          }
        ]
      },
      {
        "title": "Riesgos de cáncer en personas con mutación RAD51D",
        "subtitle": [
          {
            "desc": "Se han vinculado con riesgo incrementado de:",
            "list": ["Mama", "Trompa de Falopio", "Ovario"]
          },
          {
            "desc": "Se investiga si estas mutaciones aumentan el riesgo de otros cánceres.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con una mutación RAD51D?",
        "subtitle": [
          {
            "desc": "Opciones basadas en guías y ensayos clínicos:",
            "list": [
              "Riesgos de cáncer",
              "Cribado, detección precoz y reducción de riesgo",
              "Tratamiento"
            ]
          },
          {
            "desc": "Si das positivo, informa a tus familiares consanguíneos (primer, segundo y tercer grado) y consulta con un/a experto/a en genética.",
            "list": []
          }
        ]
      }
    ]

  },

  "STK11": {
    "title": "STK11 (síndrome de Peutz-Jeghers)",
    "subtitles": [
      {
        "title": "¿Qué es STK11 y el síndrome de Peutz-Jeghers?",
        "subtitle": [
          {
            "desc": "STK11 es un gen; las mutaciones hereditarias causan el síndrome de Peutz-Jeghers (PJS) y aumentan el riesgo de varios cánceres.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Todas las personas con PJS desarrollan cáncer?",
        "subtitle": [
          {
            "desc": "El riesgo de por vida es elevado y muchas personas con mutación heredada en STK11 desarrollarán cáncer. Seguir las guías de cribado y prevención aumenta la probabilidad de prevenirlo o detectarlo en etapas tempranas.",
            "list": []
          }
        ]
      },
      {
        "title": "Mi tumor tiene una mutación STK11, ¿significa que tengo PJS?",
        "subtitle": [
          {
            "desc": "No necesariamente. Si tu tumor tiene una mutación STK11, habla sobre consejo genético y pruebas germinales.",
            "list": []
          },
          {
            "desc": "Mutaciones en tumores (somáticas): el test de biomarcadores identifica alteraciones en células cancerosas para orientar tratamiento. Las mutaciones somáticas en STK11 son poco comunes en la mayoría de los cánceres, pero pueden ser más frecuentes en el cáncer de pulmón de células no pequeñas (NSCLC). No implican PJS.",
            "list": []
          }
        ]
      },
      {
        "title": "Mutaciones germinales y de novo en STK11",
        "subtitle": [
          {
            "desc": "Mutaciones germinales: heredadas de un progenitor; presentes en todas las células; causan PJS. La prueba genética evalúa mutaciones heredadas en STK11.",
            "list": []
          },
          {
            "desc": "Mutaciones de novo: algunas personas son las primeras en su familia con PJS. Dependiendo del momento del desarrollo, la mutación puede no estar en todas las células; si está en óvulos o espermatozoides, puede transmitirse a la descendencia.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Cómo saber si tengo PJS?",
        "subtitle": [
          {
            "desc": "La prueba genética (sangre, saliva o tejido) puede identificar mutaciones heredadas en STK11 y confirmar PJS. Es recomendable consultar con un/a experto/a en genética antes de la prueba.",
            "list": []
          }
        ]
      },
      {
        "title": "Riesgos de cáncer con mutación STK11",
        "subtitle": [
          {
            "desc": "Riesgo muy alto de varios cánceres, incluidos:",
            "list": [
              "Mama",
              "Colorrectal",
              "Endometrio",
              "Pulmón",
              "Páncreas",
              "Estómago",
              "Intestino delgado",
              "Otros"
            ]
          },
          {
            "desc": "Los riesgos comienzan a edades tempranas.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con PJS?",
        "subtitle": [
          {
            "desc": "Opciones basadas en guías y ensayos clínicos:",
            "list": [
              "Riesgos de cáncer",
              "Cribado, detección precoz y reducción de riesgo"
            ]
          },
          {
            "desc": "Estas guías se actualizan anualmente. Consulta con un/a experto/a en genética para atención basada en la evidencia más reciente e informa a familiares consanguíneos (primer, segundo y tercer grado).",
            "list": []
          }
        ]
      }
    ]

  },

  "TP53": {
    "title": "TP53 (síndrome de Li-Fraumeni)",
    "subtitles": [
      {
        "title": "¿Qué es TP53 y el síndrome de Li-Fraumeni?",
        "subtitle": [
          {
            "desc": "TP53 es un gen que ayuda a responder al daño del ADN. Las personas que nacen con mutaciones heredadas en TP53 tienen el síndrome de Li-Fraumeni y un mayor riesgo de muchos tipos de cáncer.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Todas las personas con síndrome de Li-Fraumeni desarrollan cáncer?",
        "subtitle": [
          {
            "desc": "El riesgo de por vida con una mutación heredada en TP53 es muy alto y la mayoría de las personas portadoras desarrollarán cáncer en algún momento. Seguir las guías de cribado y prevención aumenta las probabilidades de prevenirlo o detectarlo en su etapa más temprana y tratable.",
            "list": []
          }
        ]
      },
      {
        "title": "Mi tumor tiene una mutación TP53, ¿significa que tengo Li-Fraumeni?",
        "subtitle": [
          {
            "desc": "No necesariamente. Una mutación TP53 detectada solo en las células del tumor no implica síndrome de Li-Fraumeni.",
            "list": []
          }
        ]
      },
      {
        "title": "Mutaciones TP53 en tumores (somáticas)",
        "subtitle": [
          {
            "desc": "Las pruebas de tumores (biomarcadores) identifican mutaciones presentes únicamente en las células cancerosas para orientar el tratamiento. TP53 es una mutación somática común en muchos cánceres. Las mutaciones somáticas no causan síndrome de Li-Fraumeni.",
            "list": []
          }
        ]
      },
      {
        "title": "Mutaciones germinales en TP53",
        "subtitle": [
          {
            "desc": "La mayoría de las personas con TP53 germinal lo heredaron de uno de sus padres y la mutación está en todas las células del cuerpo. Las mutaciones heredadas (germinales) causan el síndrome de Li-Fraumeni. La prueba genética evalúa mutaciones germinales en TP53.",
            "list": []
          }
        ]
      },
      {
        "title": "Mutaciones de novo en TP53",
        "subtitle": [
          {
            "desc": "Algunas personas con Li-Fraumeni no heredaron la mutación de sus padres; la desarrollaron durante el desarrollo embrionario (de novo). Según el momento en que ocurrió, la mutación puede o no estar en todas las células. Si está en óvulos o espermatozoides, puede transmitirse a la descendencia.",
            "list": []
          }
        ]
      },
      {
        "title": "Señales que pueden indicar síndrome de Li-Fraumeni en la familia",
        "subtitle": [
          {
            "desc": "Ejemplos de hallazgos que pueden sugerir una mutación TP53 hereditaria:",
            "list": [
              "Cáncer de mama a edad muy temprana (especialmente ≤30 años).",
              "Sarcoma, cáncer de cerebro o carcinoma corticosuprarrenal, especialmente antes de los 45 años.",
              "Cánceres diagnosticados antes de los 30 años."
            ]
          },
          {
            "desc": "Esta no es una lista completa. Habla con un/a consejero/a genético para decidir sobre pruebas genéticas.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Cómo saber si tengo síndrome de Li-Fraumeni?",
        "subtitle": [
          {
            "desc": "La prueba genética (en sangre, saliva o tejido) puede identificar mutaciones heredadas en TP53 y otros genes. La muestra se envía a un laboratorio de genética.",
            "list": []
          },
          {
            "desc": "Es recomendable conversar con un/a experto/a en genética antes de la prueba para responder dudas y garantizar que se solicite el estudio adecuado.",
            "list": []
          }
        ]
      },
      {
        "title": "Riesgos de cáncer en personas con una mutación TP53",
        "subtitle": [
          {
            "desc": "Las personas con una mutación heredada en TP53 tienen riesgo muy alto de varios cánceres, incluidos:",
            "list": [
              "Cerebro",
              "Mama",
              "Colorrectal",
              "Páncreas",
              "Sarcomas",
              "Otros"
            ]
          },
          {
            "desc": "Los riesgos pueden comenzar a edades muy tempranas.",
            "list": []
          }
        ]
      },
      {
        "title": "¿Qué pueden hacer las personas con síndrome de Li-Fraumeni?",
        "subtitle": [
          {
            "desc": "Existen guías y ensayos clínicos que se enfocan en:",
            "list": [
              "Riesgos de cáncer asociados a TP53",
              "Cribado, detección precoz y reducción de riesgo"
            ]
          },
          {
            "desc": "Estas guías se actualizan anualmente. Habla con un/a experto/a en genética para que tu atención se base en la información más reciente.",
            "list": []
          },
          {
            "desc": "Si das positivo para una mutación TP53, informa a tus familiares consanguíneos (primer, segundo y tercer grado) y anímales a consultar con un/a experto/a en genética.",
            "list": []
          }
        ]
      }
    ]

  }
}

const mutationGenesArray = [
  'APC', 'ATM', 'BARD1', 'BRCA1', 'BRCA2', 'BRIP1', 'CDH1', 'CDKN2A', 'CDK4', 'CHEK2', 'EPCAM', 'HOXB13', 'MLH1',
  'MSH2', 'MSH6', 'MUTYH', 'NBN', 'PALB2', 'PMS2', 'PTEN', 'RAD51C', 'RAD51D', 'STK11', 'TP53'
]
const tiposDeCancerArray = [
  "cáncer de mama", "cáncer de colon", "cáncer de ovarios", "cáncer de pancreas", "cáncer de próstata", "cáncer de piel", "cáncer de endometrio"

]
function TiposDeGenes() {
  useEffect(() => { Aos.init({ duration: 500 }) })
  const theme = useTheme();
  const isSmall = !useMediaQuery(theme.breakpoints.up('md'));
  const [mutationData, setMutationData] = React.useState({ open: false, mutation: modalGenesData["APC"] });
  return <div>
    <Slide direction='right' in={true} timeout={{ enter: 875, appear: 371, exit: 372 }}>
      <div className="flex-row-a">
        <div className='flex-column' style={{ padding: (isSmall) ? '1rem' : "3rem" }}>
          <Typography variant='h5' style={{ fontWeight: 600, textAlign: isSmall ? 'center' : 'left' }}>
            Mutaciones de cancer
          </Typography>
          <Typography variant='body1' style={{ textAlign: isSmall ? 'center' : 'left' }}>
            Obtenga información sobre mutaciones genéticas específicas. Al seleccionar el tipo de mutación, puede descubrir información vital sobre los riesgos de cáncer, las pautas, la prevención y las opciones de tratamiento adaptadas a sus necesidades.
          </Typography>
        </div>
        <div style={{ minWidth: isSmall ? "auto" : "70%" }} >
          <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
            {
              mutationGenesArray.map((mutation, i: number) =>
                <div onClick={() => {
                  type key = keyof typeof modalGenesData;

                  if (mutation in modalGenesData) {
                    setMutationData({ open: true, mutation: modalGenesData[mutation as key] })
                  }
                }}>
                  <Paper data-aos='fade-up' data-aos-delay={20 + 60 * i} className="MutacionesDeGenes" elevation={2} style={{
                    background: 'linear-gradient(rgba(171, 71, 188, 0.52) 0%, rgba(99, 91, 255, 0) 92.07%) rgb(37, 37, 37)',
                    borderRadius: "100%", padding: "1rem", margin: "0.5rem", color: "#90caf9"
                  }}>{mutation}</Paper></div>)
            }
          </div>
        </div>
      </div>
    </Slide>

    <Dialog className="Mutaciones" maxWidth="lg"

      open={mutationData.open} sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
          },
        },
      }}>
      <div style={{ padding: "1rem" }}>
        {
          <div style={{ display: 'flex', width: "100%", justifyContent: "end" }}>
            <Fab
              onClick={() => {
                setMutationData({ open: false, mutation: mutationData.mutation })
              }}
              color="secondary" size='small' style={{ margin: "0rem", position: 'fixed', transform: 'translate(calc(1rem + 20px), calc(-1rem - 20px))' }}>
              <ClearIcon />
            </Fab>
          </div>
        }
        {

          <Typography variant='h5' style={{ fontWeight: 600 }}>{mutationData.mutation.title}</Typography>
        }
        {
          mutationData.mutation.subtitles.map((v: any, i: any) => <div>
            <Typography variant='h6' style={{ fontWeight: 600 }}>{v.title}</Typography>

            {
              v.subtitle.map((v1: any, i1: any) =>
                <div style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                  <Typography variant='subtitle1'>{v1.desc}</Typography>
                  {v1.list.length > 0 &&
                    <List>

                      {v1.list.map((list: any, indexList: any) =>
                        <Typography variant="subtitle2">{indexList + 1}. {list}</Typography>)
                      }
                    </List>
                  }
                </div>
              )
            }

          </div>)
        }
      </div>

    </Dialog>
  </div>
}

const TiposDeCancer = forwardRef((props, ref: Ref<HTMLDivElement>) => {
  const theme = useTheme();
  const isSmall = !useMediaQuery(theme.breakpoints.up('lg'));
  const isSmallmd = !useMediaQuery(theme.breakpoints.up('md'))
  const [showOnlyCancerType, setOnlyShowOnlyCancerType] = React.useState(true);

  return (<div
    ref={ref}
    className="Background" style={{
      textAlign: "left", background: "#282c34", padding: "1rem", color: "white",
      minHeight: "100vh", display: "flex", flexDirection: "column", justifyContent: "center",
      alignItems: isSmall ? 'center' : 'initial'
    }}>
    <Typography variant='h4' style={{ fontWeight: 600, textAlign: "center" }} data-aos='zoom-in'>
      Encuentra informacion sobre tipos de cáncer
    </Typography>
    <ButtonGroup style={{ padding: "1rem" }}
      disableElevation
      variant="contained"
      aria-label="Disabled button group"
      data-aos='fade-in'
    >
      <Button onClick={() => setOnlyShowOnlyCancerType(false)} variant={showOnlyCancerType ? 'outlined' : 'contained'}>Tipo de mutación</Button>
      <Button onClick={() => setOnlyShowOnlyCancerType(true)} variant={!showOnlyCancerType ? 'outlined' : 'contained'}>Tipo de cáncer</Button>
    </ButtonGroup>
    {
      showOnlyCancerType &&
      <Slide direction='left' in={true} timeout={{ enter: 875, appear: 371, exit: 372 }}>
        <div className='flex-column' >
          <div className="flex-row-a" style={{ padding: (isSmallmd) ? '1rem' : "3rem" }}>
            <div className='flex-column'  >
              <Typography variant='h5' style={{ textAlign: isSmallmd ? 'center' : 'left', fontWeight: '600' }}>
                Tipos de cancer
              </Typography>
              <Typography variant='body1' style={{ textAlign: isSmallmd ? 'center' : 'left' }}>
                Obtenga información sobre tipos específicos de cáncer. Al seleccionar el tipo de cáncer, puede descubrir información vital sobre su comportamiento, opciones de tratamiento y posibles resultados adaptados a sus necesidades.
              </Typography>
            </div>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", minWidth: isSmall ? "auto" : "512px", justifyContent: "center" }}>
            {
              tiposDeCancerArray.map((value, index) =>
                <Paper data-aos='fade-up' data-aos-delay={50 + index * 100}
                  elevation={3} className='TiposDeCancer'
                  style={{ marginTop: (index % 2 == 0) ? "1rem" : "0", padding: "1rem", margin: '0.5rem', display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", background: "linear-gradient(#ab47bc85  0%, rgba(99, 91, 255, 0) 92.07%) #252525" }}>
                  <img src={`TiposCancer/c${index + 1}.svg`} alt="" width={isSmall ? 50 : 100} height={isSmall ? 50 : 100} />
                  <Typography variant={isSmall ? 'subtitle2' : 'subtitle1'} style={{ textTransform: 'capitalize' }}>
                    {value}
                  </Typography>
                </Paper>)
            }
          </div>
        </div>
      </Slide>
    }
    {
      !showOnlyCancerType && <TiposDeGenes />
    }
  </div>);
});
export { TiposDeCancer };